import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GridCellLink } from './grid-cell-link.utils';

@Component({
    selector: 'app-grid-cell-text',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule],
    templateUrl: './grid-cell-text.component.html',
    styleUrl: './grid-cell-text.component.scss',
    host: {
        class: 'grid-cell-text',
    },
})
export class GridCellTextComponent {
    readonly text = input<string | number | null | undefined>();
    readonly placeholder = input<string | null | undefined>(null);
    readonly link = input<GridCellLink | null>(null);
    readonly useDxLinkStyle = input(true);
    readonly stopRowClick = input(true);

    readonly displayText = computed((): string => {
        const value = this.text();
        if (value === null || value === undefined || value === '') {
            return this.placeholder() ?? '';
        }
        return String(value);
    });

    readonly hasLink = computed((): boolean => {
        const route = this.link()?.routerLink;
        if (route === null || route === undefined) return false;
        return Array.isArray(route) ? route.length > 0 : String(route).length > 0;
    });

    readonly tooltip = computed((): string | null => {
        const label = this.displayText();
        return label.length > 0 ? label : null;
    });

    onLinkClick(event: Event): void {
        if (this.stopRowClick()) {
            event.stopPropagation();
        }
    }
}
